module.exports = __webpack_public_path__ + "img/7.16c10d76.png";